import { ChevronLeft } from 'lucide-react'
import { Button } from '@/shared/ui/Button'
import { useHostBack } from '@/shared/shell/hostNavigation'

export function HostBackButton() {
  const goBack = useHostBack()
  if (!goBack) return null
  return (
    <Button variant="ghost" size="icon" onClick={goBack} aria-label="뒤로가기">
      <ChevronLeft aria-hidden className="size-5" />
    </Button>
  )
}
